import { NgModule } from '@angular/core';
import { Routes, RouterModule, ActivatedRouteSnapshot } from '@angular/router';
import { DepartmentsComponent } from './journey/departments/departments.component';
import { LoginComponent } from './journey/login/login.component';
import { ServicesComponent } from './journey/services/services.component';
import { LocationComponent } from './journey/location/location.component';
import { CalendarComponent } from './journey/calendar/calendar.component';
import { BookingDetailsComponent } from './journey/booking-details/booking-details.component';
import { SummaryComponent } from './journey/summary/summary.component';
import { ConfirmationComponent } from './journey/confirmation/confirmation.component';
import { GuardService } from './services/guards/guard.service';
import { AccountGuardService } from './services/guards/account-guard.service';
import { SessionComponent } from './journey/session/session.component';
import { ThankyouComponent } from './journey/thankyou/thankyou.component';
import { VerifyPaymentComponent } from './journey/verify-payment/verify-payment.component';
import { LandingComponent } from './journey/landing/landing.component';
import { AgentComponent } from './agent/agent.component';
import { EstoreFailComponent } from './journey/estore-fail/estore-fail.component';
import { AccessibilityStatementComponent } from './journey/accessibility-statement/accessibility-statement.component';

const routes: Routes = [
  { path: '', redirectTo: (routeData: ActivatedRouteSnapshot) => {
    let pathStr = '/start';
    if (Object.keys(routeData.queryParams).length > 0) {
      pathStr = `${pathStr}`
      let i = 0;
      for (const param of Object.keys(routeData.queryParams)) {
        let sep = '?';
        if (i > 0) {
          sep = '&';
        }
        pathStr = `${pathStr}${sep}${param}=${routeData.queryParams[param]}`;
        i++;
      }
    }
    return pathStr;
  }, pathMatch: 'full'},
  { path: 'start', component: LandingComponent },
  { path: 'start/:service', component: LandingComponent },
  { path: 'start/:service/:resource', component: LandingComponent },
  { path: 'departments', component: DepartmentsComponent },
  { path: 'login', component: LoginComponent, data: { breadcrumb: 'Login' } },
  { path: 'services', component: ServicesComponent, data: { breadcrumb: 'Services' } },
  { path: 'locations', component: LocationComponent },
  { path: 'calendar', component: CalendarComponent, data: { breadcrumb: 'Date & Time' } },
  { path: 'booking-details', component: BookingDetailsComponent, data: { breadcrumb: 'Booking Form' } },
  { path: 'summary', component: SummaryComponent, data: { breadcrumb: 'Summary' } },
  { path: 'confirmation', component: ConfirmationComponent, data: { breadcrumb: 'Confirmation' } },
  { path: 'payment-verify/:company/:basket/:serviceItems', component: VerifyPaymentComponent },
  // Civica eStore failure / cancel landing (retry the same basket or restart).
  { path: 'estore-fail', component: EstoreFailComponent },
  { path: 'sessionExpired', component: SessionComponent },
  { path: 'thankyou', component: ThankyouComponent },
  { path: 'post-signin', component: LandingComponent },
  { path: 'agent', component: AgentComponent},
  {
    path: 'accessibility-statement',
    component: AccessibilityStatementComponent,
    data: { breadcrumb: 'Accessibility Statement' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
